import React from 'react'
import MainNav from './MainNav'

const Navbar = (props) => {

  return (
      <MainNav mobileBelow={1200} search={true} cart={false} />
    
  )
}

export default Navbar